import React from 'react'
import Our_Services from './our-services/Our_Services'
import Download_app from '../common/download-app/Download_app'

function Services() {
    return (
        <>
            <Our_Services />
            <Download_app />
        </>
    )
}

export default Services